import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { orderBy } from "lodash";
import React, { useState } from "react";
import { SelectInput, TextInput, useTranslate } from "react-admin";
import { Form } from "react-final-form";

import { useOwnerCompanyDataContext } from "../../../../contexts/OwnerCompanyDataProvider";
import { OrderService, OrderServices } from "../../../../entities";
import { documentTypes, PACKING_LIST_DOCUMENT_TYPE } from "../../../../entities/documentTypes";

const useTypeChoices = (typeChoices, translate, ownerCompanyData) => {
	const [typeChoicesState, setTypeChoicesState] = useState(() => {
		if (typeChoices) {
			return typeChoices;
		}
		const choices = orderBy(
			documentTypes.map((x) => ({
				id: x.id,
				name: translate(x.name, {
					company_name: ownerCompanyData.short_name,
					service_name: OrderServices[OrderService.intoPlukkStorage].short_name,
				}),
			})),
			["name"],
			["asc"]
		);
		return choices;
	});
	return [typeChoicesState];
};

export const DocumentEditDialog = ({ open, handleClose, doc, handleSave, typeChoices }) => {
	const translate = useTranslate();
	const { ownerCompanyData } = useOwnerCompanyDataContext();

	const [typeChoicesState] = useTypeChoices(typeChoices, translate, ownerCompanyData);
	const isPackingList = doc?.type === PACKING_LIST_DOCUMENT_TYPE;

	const onSubmit = (values) => {
		handleSave && handleSave(values);
		handleClose();
	};

	return (
		<Form onSubmit={onSubmit} initialValues={doc}>
			{(props) => (
				<Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title" fullWidth>
					<DialogTitle id="form-dialog-title">{translate("osfc.document.edit.label")}</DialogTitle>
					<DialogContent>
						<TextInput autoFocus name="title" label="osfc.fields.document.title" fullWidth />
						<SelectInput
							fullWidth
							name="type"
							label="osfc.fields.document.type"
							choices={typeChoicesState}
							disabled={isPackingList}
							helperText={isPackingList ? "osfc.document.edit.packing_list_type_locked" : undefined}
						/>
					</DialogContent>
					<DialogActions>
						<Button onClick={handleClose} color="primary">
							{translate("osfc.buttons.cancel")}
						</Button>
						<Button onClick={props.handleSubmit} color="primary">
							{translate("osfc.buttons.update")}
						</Button>
					</DialogActions>
				</Dialog>
			)}
		</Form>
	);
};
